
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/building-sites",
      function () {
        return require("private-next-pages/building-sites.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/building-sites"])
      });
    }
  